module.exports = __webpack_public_path__ + "static/media/bananas.02948230.svg";